export default __webpack_public_path__ + "assets/76aca5541bf6ca9792f09fc2b924ee0f.svg";